import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { renderTextField, renderCheckbox, renderSelectField, renderDatePicker, renderAutoComplete } from '../auth/form_helpers'
import '../../style/style.css';
import RaisedButton from 'material-ui/RaisedButton'
import Menu from 'material-ui/Menu';
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import ActionFace from 'material-ui/svg-icons/action/face';
import ActionLaunch from 'material-ui/svg-icons/action/launch';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import ContentClear from 'material-ui/svg-icons/content/clear';

var jsonpatch = require('fast-json-patch')

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  pt15: {
    paddingTop: 15,
  },
  m15: {
    marginTop: 15,
  },
};

var dontHaveGroupRegFee = true;
var identifier;
var length = 0;

class SkgroupForm extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openPopover: false
    }
  }

  handlePopoverClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      openPopover: true,
      anchorEl: event.currentTarget,
    });
  }

  handleRequestPopoverClose = () => {
    this.setState({
      openPopover: false,
    });
  }

  componentWillMount() {
    if (typeof this.props.groupregistrationfee === 'undefined') {
      dontHaveGroupRegFee = true;
    }
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  renderStartDate() {
    if (typeof this.props.groupinfos.startDate !== 'undefined') {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.startDate !== 'undefined' ?
                  this.props.tracker.values.startDate === null ? 'deleted dateInput'
                  : 'ac1 dateInput'
                : 'ac2 dateInput'
              : 'ac3 dateInput'
            : 'ac4 dateInput'
          }
          component={renderDatePicker}
          label="Kezdés dátuma"
          floatingLabelText="Kezdés dátuma"
          hintText="Kezdés dátuma"
          type="text"
          style={{width: 120}}
          defaultDate={new Date(this.props.groupinfos.startDate)}
          name="startDate" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="startDate"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.startDate !== 'undefined' ?
                this.props.tracker.values.startDate !== null ? (<div className="">
                    <IconButton onClick={this.delete("startDate")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    } else {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.startDate !== 'undefined' ?
                  this.props.tracker.values.startDate === null ? 'deleted dateInput'
                  : 'ac11 dateInput'
                : 'ac21 dateInput'
              : 'ac31 dateInput'
            : 'ac41 dateInput'
          }
          component={renderDatePicker}
          label="Kezdés dátuma"
          floatingLabelText="Kezdés dátuma"
          hintText="Kezdés dátuma"
          type="text"
          style={{width: 120}}
          name="startDate" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="startDate"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.startDate !== 'undefined' ?
                this.props.tracker.values.startDate !== null ? (<div className="">
                    <IconButton onClick={this.delete("startDate")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    }
  }

  renderEndDate() {
    if (typeof this.props.groupinfos.endDate !== 'undefined') {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.endDate !== 'undefined' ?
                  this.props.tracker.values.endDate === null ? 'deleted dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              : 'ac dateInput'
            : 'ac dateInput'
          }
          component={renderDatePicker}
          label="Befejezés dátuma"
          floatingLabelText="Befejezés dátuma"
          hintText="Befejezés dátuma"
          type="text"
          style={{width: 120}}
          defaultDate={new Date(this.props.groupinfos.endDate)}
          name="endDate" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="endDate"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.endDate !== 'undefined' ?
                this.props.tracker.values.endDate !== null ? (<div className="">
                    <IconButton onClick={this.delete("endDate")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    } else {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.endDate !== 'undefined' ?
                  this.props.tracker.values.endDate === null ? 'deleted dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              : 'ac dateInput'
            : 'ac dateInput'
          }
          component={renderDatePicker}
          label="Befejezés dátuma"
          floatingLabelText="Befejezés dátuma"
          hintText="Befejezés dátuma"
          type="text"
          style={{width: 120}}
          name="endDate" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="endDate"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.endDate !== 'undefined' ?
                this.props.tracker.values.endDate !== null ? (<div className="">
                    <IconButton onClick={this.delete("endDate")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    }
  }

  /**
    * Autocomplete handler
    *   - handleGroupSupervisor
    *   - handleGroupLeader
    *   - handleParticipants
    * auto input setting from Autocomplete value
    * 
  **/
  handleGroupSupervisor = (selectedItem) => {
      let items = selectedItem.value.props.value.split("|")
      this.props.change('groupSupervisor.name', items[0].trim())
      this.props.change('groupSupervisor.id', items[3].trim())
      this.props.change('newgroupSupervisor.name', '')
  }
  handleGroupLeader0 = (selectedItem) => {
      let items = selectedItem.value.props.value.split("|")
      items.forEach( function(item, index) {
        if (typeof item == 'undefined' || item.trim() == "undefined") {
          items[index] = ''
        }
      })
      this.props.change('leaders.[0].name', items[0].trim())
      //this.props.change('leaders.[0].email', items[1].trim())
      //this.props.change('leaders.[0].tbNumber', items[2].trim())
      this.props.change('leaders.[0].id', items[3].trim())
      this.props.change('newLeader0.name', null)
  }
  handleGroupLeader1 = (selectedItem) => {
      let items = selectedItem.value.props.value.split("|")
      items.forEach( function(item, index) {
        if (typeof item == 'undefined' || item.trim() == "undefined") {
          items[index] = ''
        }
      })
      this.props.change('leaders.[1].name', items[0].trim())
      //this.props.change('leaders.[1].email', items[1].trim())
      //this.props.change('leaders.[1].tbNumber', items[2].trim())
      this.props.change('leaders.[1].id', items[3].trim())
      this.props.change('newLeader1.name', null)
  }
  handleParticipants = (selectedItem) => {
    let items = selectedItem.value.props.value.split("|")
    items.forEach( function(item, index) {
      if (typeof item == 'undefined' || item.trim() == "undefined") {
        items[index] = ''
      }
    })
    if (items[0].trim() !== '') {
      this.props.change('participants.['+this.props.tracker.values.participants.length+'].name', items[0].trim())
    }
    if (items[1].trim() !== '') {
      this.props.change('participants.['+(this.props.tracker.values.participants.length - 1)+'].email', items[1].trim())
    }
    if (items[2].trim() !== '') {
      this.props.change('participants.['+(this.props.tracker.values.participants.length - 1)+'].tbNumber', items[2].trim())
    }
    if (items[3].trim() !== '') {
      this.props.change('participants.['+(this.props.tracker.values.participants.length - 1)+'].id', items[3].trim())
    }
    this.props.patchItem('/groups', '/'+this.props.tracker.values.id+'/participants/'+items[3].trim(), [], false)
    this.props.change('participants.new.name', null)
  }

  /**
    * Module save
    *   - saveParticipantFee
    * object making for comparable object
    * patch making
    * PATCH request
    * 
  **/
  saveParticipantFee(participant, index) {
    return () => {
      let loadedParticipantFee = this.props.groupinfos.participants[index].registrationFee;
      let editedParticipantFee = this.props.tracker.values.participants[index].registrationFee;
      if(typeof editedParticipantFee.paymentDate !== 'undefined' && editedParticipantFee.paymentDate.length !== 10) {
            editedParticipantFee.paymentDate.setMinutes(editedParticipantFee.paymentDate.getMinutes() - editedParticipantFee.paymentDate.getTimezoneOffset());
            editedParticipantFee.paymentDate = editedParticipantFee.paymentDate.toISOString().slice(0,10)
      }
      if(typeof editedParticipantFee.notice1 !== 'undefined' && editedParticipantFee.notice1.length !== 10) {
            editedParticipantFee.notice1.setMinutes(editedParticipantFee.notice1.getMinutes() - editedParticipantFee.notice1.getTimezoneOffset());
            editedParticipantFee.notice1 = editedParticipantFee.notice1.toISOString().slice(0,10)
      }
      if(typeof editedParticipantFee.notice2 !== 'undefined' && editedParticipantFee.notice2.length !== 10) {
            editedParticipantFee.notice2.setMinutes(editedParticipantFee.notice2.getMinutes() - editedParticipantFee.notice2.getTimezoneOffset());
            editedParticipantFee.notice2 = editedParticipantFee.notice2.toISOString().slice(0,10)
      }
      if (typeof editedParticipantFee.amount !== 'undefined') {
        editedParticipantFee.amount = parseInt(editedParticipantFee.amount.replace(/[' ']/g,''))
      }
      if (typeof editedParticipantFee.payed !== 'undefined') {
        editedParticipantFee.payed = parseInt(editedParticipantFee.payed.replace(/[' ']/g,''))
      }
      if (typeof editedParticipantFee.isRemissed !== 'undefined' && editedParticipantFee.isRemissed === '') {
        editedParticipantFee.isRemissed = false
      }
      var patch = jsonpatch.compare(loadedParticipantFee, editedParticipantFee)
      this.props.patchItem('/groups', '/'+this.props.groupinfos.id+'/registration-fees/'+participant, patch)
      this.props.openGroup('/groups', '/'+this.props.groupinfos.id)
    }
  }

  /**
    * render blocks with Autocomplete
    * type: Group Leaders -> 0-2 with delete
    * type: Group Supervisor -> only one with delete
    * type: Group Participants
    *   - list without delete
    *   - auto create on autocomplete select
    *   - can open participant single
    *   - don't have modules
    * 
  **/
  renderBase(type) {
    var datasource = []
    let dataSourceConfig = {
      text: 'text',
      value: 'value',
    }
    if (typeof this.props.autocomplete !== 'undefined') {
      datasource = [];
      this.props.autocomplete.map((option, index) => {
        datasource.push(
          {
            text: '',
            value: (
              <MenuItem key={index} value={option.name+' | '+option.email+' | '+option.tbNumber+' | '+option.id+' | '+option.birthday+' | '+option.indexNumber} primaryText={option.name} />
            ),
          },
        )
      })
    }

    const fetch = (target, querystring, autocomplete) => {
      this.props.fetchMessage(target, querystring, autocomplete)
    }
    if (type == "groupSupervisor") {
      if (typeof this.props.tracker !== 'undefined') {
        function getAutoComplete(event) {
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && document.activeElement.name == 'newgroupSupervisor.name' && length !== document.activeElement.value.length) {
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete4')
            window.removeEventListener("keyup", getAutoComplete);
          }
        }
        window.addEventListener("keyup", getAutoComplete)
      }
      return <Paper zDepth={0}>
        <div className="horizontal flexrow">
          {
            (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.groupSupervisor !== 'undefined') ? <IconButton
                        iconStyle={styles.smallIcon}
                        style={styles.m15}
                        href={"/persons/"+this.props.tracker.values.groupSupervisor.id} target="_blank"
                      >
                        <ActionLaunch />
                      </IconButton>
            : void(0)
          }
          <Field
            className={"itsAWeirdAnInput"}
            disabled={true}
            component={renderTextField}
            label="csoport szupervízor"
            name="groupSupervisor.name"
            style={{width: 180}}
          >
          </Field>
          {
            (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.groupSupervisor !== 'undefined') ? <IconButton
                iconStyle={styles.smallIcon}
                style={styles.m15}
                onMouseDown={this.delete("groupSupervisor.name")}
              >
                <ActionDelete />
              </IconButton>
            : void(0)
          }
        </div>
        <Field
          className="hidden"
          style={{
            display: 'none'
          }}
          component={renderTextField}
          name="groupSupervisor.id"
          type="hidden"
        />
        <Field
          className="personAutocomplete plusItem"
          component={renderAutoComplete}
          label="szupervízor hozzáadása/cseréje"
          name="newgroupSupervisor.name"
          dataSource={datasource}
          dataSourceConfig={dataSourceConfig}
          onNewRequest={this.handleGroupSupervisor}
        >
        </Field>
      </Paper>
    } else if (type == "leaders") {
      if (typeof this.props.tracker !== 'undefined') {
        function getAutoComplete(event) {
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && document.activeElement.name.substring(0,9) == 'newLeader' && length !== document.activeElement.value.length) {
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete4')
            window.removeEventListener("keyup", getAutoComplete);
          }
        }
        window.addEventListener("keyup", getAutoComplete)
      }
      let count = 0;
      if (typeof this.props.tracker !== 'undefined') {
        return <div>
          <Paper zDepth={0}>
            <div className="horizontal flexrow">
              {
                (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.leaders !== 'undefined' && typeof this.props.tracker.values.leaders[0] !== 'undefined' && this.props.tracker.values.leaders[0] !== null && typeof this.props.tracker.values.leaders[0].id !== 'undefined' && this.props.tracker.values.leaders[0].id !== null) ? <IconButton
                            iconStyle={styles.smallIcon}
                            style={styles.m15}
                            href={"/persons/"+this.props.tracker.values.leaders[0].id} target="_blank"
                          >
                            <ActionLaunch />
                          </IconButton>
                : void(0)
              }
              <Field
                className={"itsAWeirdAnInput"}
                disabled={true}
                component={renderTextField}
                label="1. csoportvezető"
                name="leaders.[0].name"
                style={{width: 180}}
              >
              </Field>
              {
                (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.leaders !== 'undefined' && typeof this.props.tracker.values.leaders[0] !== 'undefined' && this.props.tracker.values.leaders[0] !== null && typeof this.props.tracker.values.leaders[0].id !== 'undefined' && this.props.tracker.values.leaders[0].id !== null) ? <IconButton
                    iconStyle={styles.smallIcon}
                    style={styles.m15}
                    onMouseDown={this.delete("leaders.[0].name")}
                  >
                    <ActionDelete />
                  </IconButton>
                : void(0)
              }
            </div>
            <Field
              className="hidden"
              style={{
                display: 'none'
              }}
              component={renderTextField}
              name="leaders.[0].id"
              type="hidden"
            />
            <Field
              className="personAutocomplete plusItem"
              component={renderAutoComplete}
              label="1. csoportvezető hozzáadása"
              name="newLeader0.name"
              dataSource={datasource}
              dataSourceConfig={dataSourceConfig}
              onNewRequest={this.handleGroupLeader0}
            >
            </Field>
          </Paper>
          <Paper zDepth={0}>
            <div className="horizontal flexrow">
              {
                (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.leaders !== 'undefined' && typeof this.props.tracker.values.leaders[1] !== 'undefined' && this.props.tracker.values.leaders[1] !== null) ? <IconButton
                            iconStyle={styles.smallIcon}
                            style={styles.m15}
                            href={"/persons/"+this.props.tracker.values.leaders[1].id} target="_blank"
                          >
                            <ActionLaunch />
                          </IconButton>
                : void(0)
              }
              <Field
                className={"itsAWeirdAnInput"}
                disabled={true}
                component={renderTextField}
                label="2. csoportvezető"
                name="leaders.[1].name"
                style={{width: 180}}
              >
              </Field>
              {
                (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.leaders !== 'undefined' && typeof this.props.tracker.values.leaders[1] !== 'undefined' && this.props.tracker.values.leaders[1] !== null) ? <IconButton
                    iconStyle={styles.smallIcon}
                    style={styles.m15}
                    onMouseDown={this.delete("leaders.[1].name")}
                  >
                    <ActionDelete />
                  </IconButton>
                : void(0)
              }
            </div>
            <Field
              className="hidden"
              style={{
                display: 'none'
              }}
              component={renderTextField}
              name="leaders.[1].id"
              type="hidden"
            />
            <Field
              className="personAutocomplete plusItem"
              component={renderAutoComplete}
              label="2. csoportvezető hozzáadása"
              name="newLeader1.name"
              dataSource={datasource}
              dataSourceConfig={dataSourceConfig}
              onNewRequest={this.handleGroupLeader1}
            >
            </Field>
          </Paper>
        </div>
      }
    } else if (type == "participants") {
      if (typeof this.props.tracker !== 'undefined') {
        function getAutoComplete(event) {
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && document.activeElement.name == 'participants.new.name' && length !== document.activeElement.value.length) {
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete4')
            window.removeEventListener("keyup", getAutoComplete);
          }
        }
        window.addEventListener("keyup", getAutoComplete)
      }
      let count = 0;
      if (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.participants !== 'undefined') {
        return <div>
          <Field
            className="personAutocomplete plusItem"
            component={renderAutoComplete}
            label="Új résztvevő"
            name={"participants.new.name"}
            dataSource={datasource}
            dataSourceConfig={dataSourceConfig}
            onNewRequest={this.handleParticipants}
          >
          </Field>
          {
            this.props.tracker.values.participants.map((option, index) => {
              let email;
              if (typeof option.email !== "undefined") {
                if (option.email.length > 0) {
                  email = <span>
                    <span style={{color: darkBlack}}>Email:</span>
                    <span> {option.email} </span>
                  </span>
                }
              }
              let birthday;
              if (typeof option.birthday !== "undefined") {
                if (option.birthday.length > 0) {
                  birthday = <span>
                    <span style={{color: darkBlack}}>Született:</span>
                    <span> {option.birthday} </span>
                  </span>
                }
              }
              // registrationFee
                let paymentDate;
                if (typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' && typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined') {
                  paymentDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.paymentDate === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="befizetés időpontja"
                      floatingLabelText="befizetés időpontja"
                      hintText="befizetés időpontja"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].registrationFee.paymentDate)}
                      name={"participants.["+index+"].registrationFee.paymentDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.paymentDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.paymentDate !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.paymentDate")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  paymentDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.paymentDate === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="befizetés időpontja"
                      floatingLabelText="befizetés időpontja"
                      hintText="befizetés időpontja"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].registrationFee.paymentDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.paymentDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.paymentDate !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.paymentDate")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let notice1;
                if (typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' && typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined') {
                  notice1 = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.notice1 === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="első felszólító levél"
                      floatingLabelText="első felszólító levél"
                      hintText="első felszólító levél"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].registrationFee.notice1)}
                      name={"participants.["+index+"].registrationFee.notice1"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.notice1"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.notice1 !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.notice1")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  notice1 = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.notice1 === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="első felszólító levél"
                      floatingLabelText="első felszólító levél"
                      hintText="első felszólító levél"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].registrationFee.notice1"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.notice1"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.notice1 !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.notice1")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let notice2;
                if (typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' && typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined') {
                  notice2 = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.notice2 === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="második felszólító levél"
                      floatingLabelText="második felszólító levél"
                      hintText="második felszólító levél"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].registrationFee.notice2)}
                      name={"participants.["+index+"].registrationFee.notice2"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.notice2"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.notice2 !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.notice2")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  notice2 = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.notice2 === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="második felszólító levél"
                      floatingLabelText="második felszólító levél"
                      hintText="második felszólító levél"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].registrationFee.notice2"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.notice2"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.notice2 !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.notice2")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let regFee = <Paper zDepth={1}>
                    <label>Regisztrációs díj</label>
                    <br />
                    <Field
                      component={renderTextField}
                      floatingLabelText="a díj teljes értéke (Ft)"
                      name={"participants.["+index+"].registrationFee.amount"}
                      type="text"/>
                    <Field
                      component={renderTextField}
                      floatingLabelText="befizetett összeg (Ft)"
                      name={"participants.["+index+"].registrationFee.payed"}
                      type="text"/>
                    {paymentDate}
                    {notice1}
                    {notice2}
                    <Field
                      component={renderCheckbox}
                      label="elengedve"
                      name={"participants.["+index+"].registrationFee.isRemissed"}
                      style={styles.checkbox}
                    />
                  </Paper>
              // registrationFee end
              return <Card
                  key={index}
                  className={option.name === false ? 'hidden' : 'shw'}>
                <CardHeader
                  title={
                    <div className="horizontal">
                      <div>
                        <a href={"/persons/"+option.id} target="_blank">{option.name}</a>
                      </div>
                      <IconButton
                        iconStyle={styles.smallIcon}
                        style={{marginLeft: 15, padding: 0, width: 24, height: 24}}
                        href={"/persons/"+option.id} target="_blank"
                      >
                        <ActionLaunch />
                      </IconButton>
                    </div>
                  }
                  subtitle={
                    <small style={{color: lightBlack}}>
                      {email}
                      {birthday}
                    </small>
                  }
                  actAsExpander={true}
                  showExpandableButton={true}
                />
                <CardText expandable={true}>
                  <div className='flexContainer pt40'>
                    <div className='fullAbsolute'>
                      <span className='beforeButton'>
                        {option.name} törlése a résztvevők közül: 
                      </span>
                      <IconButton
                        iconStyle={styles.smallIcon}
                        style={{marginLeft: 0, padding: 0, width: 24, height: 24}}
                        onTouchTap={this.removeParticipant(option.id)}
                      >
                        <ActionDelete />
                      </IconButton>
                    </div>
                    {regFee}
                  </div>
                </CardText>
              </Card>
            })
          }
        </div>
      }
    }
  }

  /**
    * Helper for group registration fee reequest
    * 
  **/
  getGroupRegFee() {
    if (typeof this.props.groupinfos !== "undefined" && typeof this.props.groupregistrationfee == "undefined") {
      if (dontHaveGroupRegFee) {
        dontHaveGroupRegFee = false;
        if (this.props.groupinfos.positionNumber !== '') {
          this.props.openGroupregistrationfee('/groups', '/'+this.props.groupinfos.id+'/group-registration-fee', '');
        }
      }
    }
  }

  renderGroupRegistrationFee() {
      let defaultDate = null;
      if (typeof this.props.groupinfos.groupRegistrationFee !== "undefined") {
        if (typeof this.props.groupinfos.groupRegistrationFee.paymentDate !== "undefined") {
          return <Paper zDepth={1}>
            <label>Csoportregisztrációs díj:</label>
            <br />
            <Field
              component={renderTextField}
              floatingLabelText="fizetendő összeg (Ft)"
              name="groupRegistrationFee.amount"
              type="text"/>
            <Field
              component={renderTextField}
              floatingLabelText="fizetve (Ft)"
              name="groupRegistrationFee.payed"
              type="text"/>
            <Field
              className={
                typeof this.props.tracker !== 'undefined' ?
                  typeof this.props.tracker.values !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                      typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                        this.props.tracker.values.groupRegistrationFee.paymentDate === null ? 'deleted dateInput'
                        : 'ac dateInput'
                      : 'ac dateInput'
                    : 'ac dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              }
              component={renderDatePicker}
              label="Befizetés dátuma."
              floatingLabelText="Befizetés dátuma."
              hintText="Befizetés dátuma."
              type="text"
              style={{width: 120}}
              defaultDate={new Date(this.props.groupinfos.groupRegistrationFee.paymentDate)}
              name="groupRegistrationFee.paymentDate" />
            <Field
              component={renderTextField}
              className="dateText"
              floatingLabelText=""
              name="groupRegistrationFee.paymentDate"
              type="text"
            />
            {
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                      this.props.tracker.values.groupRegistrationFee.paymentDate !== null ? (<div className="">
                          <IconButton onClick={this.delete("groupRegistrationFee.paymentDate")} className="deleteIcon">
                            <ContentClear />
                          </IconButton>
                        </div>)
                      : void(0)
                    : void(0)
                  : void(0)
                : void(0)
              : void(0)
            }
            <Field
              component={renderTextField}
              floatingLabelText="számla száma"
              name="groupRegistrationFee.invoiceNumber"
              type="text"/>
          </Paper>
        } else {
          return <Paper zDepth={1}>
            <label>Csoportregisztrációs díj:</label>
            <br />
            <Field
              component={renderTextField}
              floatingLabelText="fizetendő összeg (Ft)"
              name="groupRegistrationFee.amount"
              type="text"/>
            <Field
              component={renderTextField}
              floatingLabelText="fizetve (Ft)"
              name="groupRegistrationFee.payed"
              type="text"/>
            <Field
              className={
                typeof this.props.tracker !== 'undefined' ?
                  typeof this.props.tracker.values !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                      typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                        this.props.tracker.values.groupRegistrationFee.paymentDate === null ? 'deleted dateInput'
                        : 'ac dateInput'
                      : 'ac dateInput'
                    : 'ac dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              }
              component={renderDatePicker}
              label="Befizetés dátuma."
              floatingLabelText="Befizetés dátuma."
              hintText="Befizetés dátuma."
              type="text"
              style={{width: 120}}
              name="groupRegistrationFee.paymentDate" />
            <Field
              component={renderTextField}
              className="dateText"
              floatingLabelText=""
              name="groupRegistrationFee.paymentDate"
              type="text"
            />
            {
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                      this.props.tracker.values.groupRegistrationFee.paymentDate !== null ? (<div className="">
                          <IconButton onClick={this.delete("groupRegistrationFee.paymentDate")} className="deleteIcon">
                            <ContentClear />
                          </IconButton>
                        </div>)
                      : void(0)
                    : void(0)
                  : void(0)
                : void(0)
              : void(0)
            }
            <Field
              component={renderTextField}
              floatingLabelText="számla száma"
              name="groupRegistrationFee.invoiceNumber"
              type="text"/>
          </Paper>
        }
      } else {
        return <Paper zDepth={1}>
          <label>Csoportregisztrációs díj:</label>
          <br />
          <Field
            component={renderTextField}
            floatingLabelText="fizetendő összeg (Ft)"
            name="groupRegistrationFee.amount"
            type="text"/>
          <Field
            component={renderTextField}
            floatingLabelText="fizetve (Ft)"
            name="groupRegistrationFee.payed"
            type="text"/>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                      this.props.tracker.values.groupRegistrationFee.paymentDate === null ? 'deleted dateInput'
                      : 'ac dateInput'
                    : 'ac dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              : 'ac dateInput'
            }
            component={renderDatePicker}
            label="Befizetés dátuma."
            floatingLabelText="Befizetés dátuma."
            hintText="Befizetés dátuma."
            type="text"
            style={{width: 120}}
            name="groupRegistrationFee.paymentDate" />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="groupRegistrationFee.paymentDate"
            type="text"
          />
          {
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                  typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                    this.props.tracker.values.groupRegistrationFee.paymentDate !== null ? (<div className="">
                        <IconButton onClick={this.delete("groupRegistrationFee.paymentDate")} className="deleteIcon">
                          <ContentClear />
                        </IconButton>
                      </div>)
                    : void(0)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          }
          <Field
            component={renderTextField}
            floatingLabelText="számla száma"
            name="groupRegistrationFee.invoiceNumber"
            type="text"/>
        </Paper>
      }
  }

  delete (text) {
    return () => {
        this.props.change(text, null)
    }
  }

  removeParticipant (id) {
    return () => {
      let signedToRemove;
      this.props.tracker.values.participants.map((option, index) => {
        if (option.id == id) {
          signedToRemove = index;
        }
      })
      console.log(signedToRemove)
      this.props.tracker.values.participants[signedToRemove].remove
      this.props.change('participants.['+signedToRemove+'].name', false)
    }
  }

  render() {
    if(typeof this.props.groupinfos !== 'undefined' && typeof this.props.grouptypes !== 'undefined') {
      const {handleSubmit} = this.props
      this.getGroupRegFee()
      return (
        <div>
            {this.renderAlert()}
            <form onSubmit={handleSubmit} style={styles.pt15} className='formFormat' >
              <div className="full">
                <Field
                  component={renderTextField}
                  floatingLabelText="pozíció szám"
                  name="positionNumber"
                  style={{
                    display: "inline-block",
                    maxWidth: 320
                  }}
                  type="text"/>
              </div>
              <div className='flexContainer' style={{paddingTop: 60}}>
                <Paper zDepth={1}>
                  <label>Csoport adatok:</label>
                  <br />
                  <Field
                    className="hidden"
                    style={{
                      display: 'none'
                    }}
                    component={renderTextField}
                    name="id"
                    type="hidden"
                  />

                  <Field
                    component={renderSelectField}
                    floatingLabelText={"típus:"}
                    name={"type"}
                  >
                    {
                      this.props.grouptypes.map((option, index) => {
                        if (option.value.indexOf("önismereti") > -1) {
                          return <MenuItem key={index} value={option.value} primaryText={option.value} />
                        }
                      })
                    }
                  </Field>
                  {this.renderStartDate()}
                  {this.renderEndDate()}
                  <Field
                    component={renderTextField}
                    floatingLabelText="óraszám"
                    name="lessonCount"
                    type="text"/>
                </Paper>
                <Paper zDepth={1}>
                  <label>Vezetők:</label>
                  <br />
                  {
                    this.renderBase('leaders')
                  }
                  {
                    this.renderBase('groupSupervisor')
                  }
                </Paper>
                <Paper zDepth={1}>
                  <label>Egyéb adatok:</label>
                  <br />
                  <Field
                    component={renderTextField}
                    floatingLabelText="Helyszín"
                    name="location"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="Létszám"
                    name="participantCount"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="Képzési díj"
                    name="registrationFee"
                    type="text"/>
                  <br />
                  <Field
                    component={renderCheckbox}
                    label="jegyzőkönyv leadva"
                    name="recordDelivered"
                    style={styles.checkbox}
                  />
                </Paper>

                <Paper zDepth={1}>
                  <label>Megjegyzések:</label>
                  <br />
                  {
                    this.props.groupinfos.comments.map((option, index) => {
                      if (option !== null && option.text !== null) {
                        return <div key={index} className={this.props.tracker.values.comments[index].text === null ? 'hidden horizontal' : 'shw horizontal'}>
                          <Field
                            className='itsAWeirdAnInput'
                            component={renderTextField}
                            floatingLabelText={"megjegyzés ("+option.time.substring(0,10)+")"}
                            name={"comments.["+index+"].text"}
                            multiLine={true}
                            disabled={true}
                            rows={1}
                            rowsMax={4}
                            type="text"
                          />
                          <IconButton
                            iconStyle={styles.smallIcon}
                            style={styles.small}
                            onMouseDown={this.delete("comments.["+index+"].text")}
                          >
                            <ActionDelete />
                          </IconButton>
                        </div>
                      }
                    })
                  }
                  <div className="horizontal">
                    <Field
                      component={renderTextField}
                      floatingLabelText="új megjegyzés"
                      hintText="új megjegyzés"
                      type="text"
                      multiLine={true}
                      rows={1}
                      rowsMax={4}
                      name="commentsnew.text" />
                  </div>
                </Paper>
                {
                  this.renderGroupRegistrationFee()
                }
              </div>
              <Paper zDepth={1} className='w100 p15 fullWidth' style={this.props.groupinfos.isSaved ? {} : {display : 'none'}} >
                <div>
                <label>Résztvevők:</label>
                <br />
                {
                  this.renderBase('participants')
                }
                </div>
              </Paper>

              <div style={{display: 'none'}}>
                <Paper  zDepth={1} className='flexEnd p15'>
                  <RaisedButton className="PersonFormSubmitButton" type="submit" label="mentés" primary={true} labelColor={'#FFFFFF'}/>
                </Paper>
              </div>
            </form>
        </div>
      )
    } else{
      return (
        <div>
            {this.renderAlert()}
            <form>
              <div>.
              </div>
            </form>
        </div>
      )
    }
  }
}

const validate = values => {
  const errors = {}

  if (values.password !== values.passwordConfirmation) {
    errors.password = 'Passwords must match'
  }
  if (!values.password) {
    errors.password = 'Please enter a password'
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Please confirm your password'
  }

  return errors
}

SkgroupForm = reduxForm({
  form: 'skgroup',
  validate
})(SkgroupForm)

// You have to connect() to any reducers that you wish to connect to yourself
SkgroupForm = connect(
  state => ({
    initialValues: typeof state.groups.thisgroup !== 'undefined' ? state.groups.thisgroup.type !== 'unset' ? state.groups.thisgroup : {'id' : state.groups.thisgroup.id, 'type' : "önismereti"} : state.groups.thisgroup, // pull initial values from reducer
    enableReinitialize : true
  })
)(SkgroupForm)

export default SkgroupForm


// WEBPACK FOOTER //
// ./src/components/selfknowledgegroups/skgroup_form.js